// extracted by mini-css-extract-plugin
export default {"screenFill":"ScreenFillStyles_screenFill__iCdsh"};